import {mockups} from "../mockups";
import {
    getRightPrice,
    getRightTerm,
    hideModal,
    initSelects,
    numberFormat,
    showModal,
    validateCheckPasswordInput
} from "../components/helpers";
import {validateField, validateForm} from "../components/form/validator";
import {initMaskedInput, initPlaceholders} from "../components/form/inputs";

export function initCartPage() {
    const AJAX_MODE = 'prod';

    let AJAX_AUTH_URL = '';
    let AJAX_USER_PROFILE_URL = '';

    if(AJAX_MODE === 'dev'){
        AJAX_AUTH_URL = '';
        AJAX_USER_PROFILE_URL = '';

    }else if(AJAX_MODE === 'test'){
        AJAX_AUTH_URL = 'https://ksid-api.internetlab.ru'
        AJAX_USER_PROFILE_URL = 'https://ksid-api.internetlab.ru/api';

    }else if(AJAX_MODE === 'prod'){
        AJAX_AUTH_URL = 'https://api.pfcks.ru';
        AJAX_USER_PROFILE_URL = 'https://api.pfcks.ru/api';
    }

    const $cartWrapper = $('[data-cart-items-wrapper]');
    const $orderPrice = $('[data-order-price]');
    const $deliveryPrice = $('[data-delivery-price]');
    const $salePrice = $('[data-sale-price]');
    const $fullOrderPrice = $('[data-full-price]');
    const $cartItemsCount = $('[data-cart-items-count]');
    const $userNameInput = $('#user_name');
    const $userLastNameInput = $('#user_lastName');
    const $userPhoneInput = $('#user_phone');
    const $userEmailInput = $('#user_email');
    const $selfDeliveryBlock = $('[data-self-delivery]');
    const $postDeliveryBlock = $('[data-post-delivery]');
    const $cartStatusModal = $('#cart_status_modal');
    const $dynamicCartErrorModal = $('#cart_dynamic_error_modal');
    const $closeCartStatusModal = $('[data-close-cart-status-modal]');
    const $headerCartCount = $('[data-cart-count-desk]');
    const $mobCartCount = $('[data-cart-count-mob]');
    const $pagePreloader = $('#page_preloader');
    const $fullScreenPreloader = $('#fullscreen_preloader');
    const $bonusesSwitcher = $('.toggle-bonuses');
    const $checkPasswordModal = $('#send_password_modal');
    const $bonusesWriteOff = $('[data-bonuses-write-off]');
    const $bonusesAll = $('[data-bonuses-all]');

    const USER = {
        name: '',
        phone: '',
        email: '',
        lastname: '',
        city: '',
        address: '',
    }

    const PROMOCODE = {
        isPromocodesAvailable: false,
        isPromocodeAccepted: false,
        discount_value: 0,
        discount_type: '',
        min_value: null,
        code: null
    }

    const ORDER_PRICE_FROM_BACK = {
        // полная стоимость заказа - скидка по промокоду - бонусы
        writeOff: 0,

        // полная стоимость заказа - скидка по промокоду
        accrue: 0,

        // полная стоимость заказ
        fullPrice: 0
    }

    if ($('#cart_page_landing').length !== 0) {
        init();
    }

    let cartItemsFullCount = 0;
    let userPoints = 0;
    let isUserAuthorized = false;
    let sendPasswordTimeInterval = null;
    let deliveryPrice = 0;
    let deliveryTime = 0;

    let fullOrderPrice = 0;
    let bonusesWriteOff = 0;

    function init() {
        initMaskedInput();
        initPlaceholders();
        getCart();

        function getCart() {
            const data = {
                ajaxAction: "get"
            };

            $.ajax({
                url: '/ajax/cart/',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (data) {
                        successFn(data);

                    } else {
                        errorFn();
                    }
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.cart;
                        if (data) {
                            successFn(data.payload);

                        } else {
                            errorFn();
                        }

                    } else {
                        errorFn();
                    }
                },
                timeout: 30000
            });

            function successFn(payload) {

                if (payload?.cartItems.length === 0) {
                    showNoCartItemsMessage();
                    $pagePreloader.hide();

                } else {
                    const result = renderCartItems(payload);
                    $cartWrapper.append(result);

                    if (payload?.user?.name) {
                        $userNameInput.val(`${payload?.user?.name}`);
                        $userNameInput.parents('.field').removeClass('empty').addClass('success');
                    }

                    if (payload?.user?.phone) {
                        $userPhoneInput.val(`${payload?.user?.phone}`);
                        $userPhoneInput.parents('.field').removeClass('empty').addClass('success');
                    }

                    if (payload?.user?.lastname) {
                        $userLastNameInput.val(`${payload?.user?.lastname}`);
                        $userLastNameInput.parents('.field').removeClass('empty').addClass('success');
                    }

                    if (payload?.user?.city) {
                        $('#user_city').val(`${payload?.user?.city}`);
                        $('#user_city').parents('.field').removeClass('empty').addClass('success');
                    }

                    if (payload?.user?.address) {
                        $('#user_address').val(`${payload?.user?.address}`);
                        $('#user_address').parents('.field').removeClass('empty').addClass('success');
                    }

                    //если есть имеил - user авторизован - скрываем предложение о входе в лк
                    if (payload?.user?.email) {
                        $userEmailInput.val(`${payload?.user?.email}`);
                        $userEmailInput.parents('.field').removeClass('empty').addClass('success');
                        isUserAuthorized = true;
                        getPoints();
                        $('[data-enter-profile-block]').hide();
                        $pagePreloader.hide();

                        //иначе - скрываем блок со списанием баллов
                    } else {
                        getPoints();
                        $('[data-use-user-points-block]').hide();
                        $('.promocodes-block').hide();
                        $pagePreloader.hide();
                    }

                    //промокод
                    if (payload?.canUsePromoCode){
                        PROMOCODE.isPromocodesAvailable = true;
                        $('.promocodes-block').removeClass('hide');
                    }

                    //скрываем поле срок доставки на ините
                    $('[data-delivery-time]').hide();

                    //убираем overflow для секции, чтобы блок с общей стоимостью стал липким
                    $('[data-main-cart-container]').parent().css('overflow', 'inherit');

                    initSelects();
                    initHandlers();
                }
            }

            function errorFn() {
                console.log('bad');
            }
        }

        function renderCartItems(payload) {
            let result = '';
            let orderPrice = 0;
            let salePrice = 0;
            let orderPriceWithoutSale = 0;
            let countErrors = 0;

            payload.cartItems.forEach(cartItem => {
                const cartItemJSON = JSON.stringify(cartItem);
                const cartItemCount = cartItem.count;
                const cartItemLimitCount = cartItem.maxCount;
                const cartItemPrice = numberFormat(cartItem.price * cartItem.count, '', '', ' ');
                let priceForItem = cartItem.price;
                let sizeHTML = '';
                let noSizeClass = 'no-size';
                let errorCountClass = '';
                cartItemsFullCount += cartItem.count;

                const isThishirtWithOptions = cartItem.hasOwnProperty('options');

                let cartItemPriceHTML = `<div class="price-wrapper">
                                                <span class="h4-bold no-margin-top price" data-cart-item-price="${cartItem.price * cartItem.count}">${cartItemPrice} ₽</span>
                                            </div>`;
                let $select = '';

                Array.from({length: cartItemLimitCount}, (v, k) => k + 1).forEach(value => {
                    if (value === cartItemCount) {
                        $select += `<option selected value="${value}">${value}</option>`;

                    } else {
                        $select += `<option value="${value}">${value}</option>`;
                    }
                });

                //если выбранное количество больше, чем лимит - добавляем в конец выбранное количество
                // и добавляем сообщение об ошибке для пользователя
                if(cartItemCount > cartItemLimitCount){
                    errorCountClass = 'error-count';
                    $select += `<option disabled selected class="error-count" value="${cartItemCount}">${cartItemCount}</option>`;
                    countErrors++;
                }

                if (cartItem.isDiscount) {
                    const cartItemDiscountPrice = numberFormat(+cartItem.discountPrice * +cartItemCount, '', '', ' ');

                    cartItemPriceHTML = `<div class="price-wrapper">
                                                <span class="old-price" data-cart-item-sale-price="${+cartItem.price * +cartItemCount}">${cartItemPrice} ₽</span>
                                                <span class="h4-bold no-margin-top price" data-cart-item-price="${cartItem.discountPrice * cartItem.count}">${cartItemDiscountPrice} ₽</span>
                                            </div>`;

                    salePrice += +cartItem.price * +cartItemCount - +cartItem.discountPrice * +cartItemCount;
                    orderPrice += +cartItem.discountPrice * +cartItem.count;

                    priceForItem = cartItem.discountPrice;

                } else {
                    orderPrice += +cartItem.price * +cartItem.count;
                }

                orderPriceWithoutSale += +cartItem.price * +cartItem.count;

                if (cartItem.chosenSize) {
                    sizeHTML = ` <div class="size">
                                        <span class="body-16 color-gray-text margin-right-14 size-title">Размер:</span>
                                        <span class="h5-bold size-value no-margin-top">${cartItem.chosenSize}</span>
                                    </div>`

                    noSizeClass = '';
                }

                let cartItemName = cartItem.name;

                if(isThishirtWithOptions){
                    cartItemName = cartItem.name + ' (индивидуальный заказ)';
                }

                result += `
                    <div class="cart-item ${errorCountClass}" data-cart-item-info='${cartItemJSON}'>
                        <div class="main-cart-item-info">
                            <img class="margin-right-32 hide-mobile" src="${cartItem.img}"/>
                            <div class="info">
                                <div class="text-block">
                                    <img class="hide-desktop" src="${cartItem.img}"/>
                                    <div class="text-block-info ${noSizeClass}">
                                        <a href="${cartItem.link}" class="h4-tablet-bold no-margin-bottom name">${cartItemName}
                                    </a>
                                        ${sizeHTML}
                                        ${cartItemPriceHTML}
                                    </div>
                                </div>
                                <div class="item-count">
                                    <div class="count-wrapper margin-right-12-mob">
                                        <span class="body-16 color-gray-text margin-right-14 hide-mobile">Количество: </span>
                                        <div class="choices ${errorCountClass}">
                                            <select class="select">
                                                ${$select}
                                            </select>
                                        </div>
                                    </div>
                                    <div class="body-16 margin-right-auto hide-desktop">
                                        ${numberFormat(priceForItem, 0, '', ' ')} ₽ / шт.
                                    </div>
                                    <span class="cart-item-delete">Удалить</span>
                                </div>
                                <div class="body-16 hide-mobile">
                                    ${numberFormat(priceForItem, 0, '', ' ')} ₽ / шт.
                                </div>
                            </div>
                        </div>
                        <div class="error-count-text">Недопустимое количество товара</div>
                    </div>`;
            });

            fullOrderPrice = orderPrice;

            $cartItemsCount.text(`${cartItemsFullCount} ${getRightTerm(cartItemsFullCount, 'товар', 'товара', 'товаров')}`);
            $orderPrice.text(`${numberFormat(orderPriceWithoutSale, '', '', ' ')} ₽`);

            if(+salePrice === 0){
                $salePrice.text(`${numberFormat(salePrice, '', '', ' ')} ₽`);

            }else{
                $salePrice.text(`- ${numberFormat(salePrice, '', '', ' ')} ₽`);
            }

            $fullOrderPrice.text(`${numberFormat(orderPrice, '', '', ' ')} ₽`);

            //проверка на доступность доставки
            if(payload.deliveryAvailability){
                $('input[name="delivery"][value="2"]').parent().removeClass('disabled');
                $('[data-post-delivery]').removeClass('no-delivery');

            }else{
                $('input[name="delivery"][value="2"]').parent().addClass('disabled');
                $('[data-post-delivery]').addClass('no-delivery');
            }

            //рендер доступных магазинов
            if(payload.storages.length){
                let result = '';
                payload.storages.forEach(storage => {
                    result += `<label class="radio margin-right-32">${storage.name}
                                    <input type="radio" value="${storage.id}" name="address">
                                    <span class="checkmark"></span>
                               </label>`
                });

                $('[data-self-delivery]').html(result);
                $('input[name="delivery"][value="1"]').parent().removeClass('disabled');

            }else{
                $('[data-self-delivery]').html('<div class="error-count-text display-block">Недопустимое количество товара для самовывоза</div>');
                $('input[name="delivery"][value="1"]').parent().addClass('disabled');
                countErrors++;

            }

            //если есть ошибки по количеству товаров - disable кнопки
            if(countErrors > 0){
                $('[data-submit-order]').addClass('disabled');

            }else{
                $('[data-submit-order]').removeClass('disabled');
            }

            $('[data-submit-order]').addClass('disabled');

            //если находимся на доставке и она доступна - убираем disable
            if(payload.deliveryAvailability && $('input[name="delivery"][value="2"]').prop('checked')){
                $('[data-submit-order]').removeClass('disabled');
            }

            //выключаем бонусы (для ререндера и последующего пересчета заказа)
            $bonusesSwitcher.find('.switcher-gray').removeClass('active');

            return result;
        }

        function initHandlers() {
            //удаление товара
            $('.cart-item-delete').on('click', e => {
                const $clickedDelete = $(e.currentTarget);
                const cartItemInfo = $clickedDelete.parents('.cart-item').data('cart-item-info');

                removeCartItem(cartItemInfo);
            });

            //изменение количества товара
            $('body').on('change', '.select.choices__input', e => {
                const $changedSelect = $(e.currentTarget);
                const cartItemInfo = $changedSelect.parents('.cart-item').data('cart-item-info');
                cartItemInfo.count = $changedSelect.val();

                const ajaxData = {
                    ajaxAction: "changeCount",
                    itemCartId: +cartItemInfo.itemCartId,
                    count: +cartItemInfo.count
                }

                editCartItem(ajaxData, cartItemInfo);
            });

            //подтверждение заказа
            $('[data-submit-order]').on('click', () => {
                const currentDeliveryType = $('input[name="delivery"]:checked').val();

                if (validateInputs(currentDeliveryType)) {

                    if (isUserAuthorized) {
                        sendOrder();

                    } else {
                        USER.city = $('#user_city').val();
                        USER.name = $userNameInput.val();
                        USER.lastname = $('#user_lastName').val();
                        USER.address = $('#user_address').val();

                        showFullScreenPreloader();
                        sendPassword();
                        $('[data-user-email]').text($userEmailInput.val());
                        $checkPasswordModal.addClass('fade-in-show');
                    }
                }
            });

            //закрытие модалки отправка пароля
            $('.return-block').on('click', () => {
                $checkPasswordModal.removeClass('fade-in-show');
                $('.check-password-error-block').hide();
                clearInterval(sendPasswordTimeInterval);
                $('#email_code').val('').removeClass('error').addClass('empty');
            });

            //переключение доставки
            $('input[name="delivery"]').on('change', e => {
                const val = $('input[name="delivery"]:checked').val();

                if (val === '1') {
                    $selfDeliveryBlock.show();
                    $postDeliveryBlock.hide();
                    $('[data-real-cash]').removeClass('disabled');
                    $('[data-delivery-time]').hide();

                    //если не выбран магазин самовывоза - disable на кнопку заказа
                    if(!$('input[name="address"]').prop('checked')){
                        $('[data-submit-order]').addClass('disabled');

                    }else{
                        $('[data-submit-order]').removeClass('disabled');
                    }

                } else if (val === '2') {
                    $selfDeliveryBlock.hide();
                    $postDeliveryBlock.show();
                    $('[data-real-cash]').addClass('disabled');
                    $('[data-online-cash] input').prop('checked', true);

                    //при переключении - сбасываем ошибки (доступна только доставка - на самовывоз уже не переключимся)
                    $('[data-submit-order]').removeClass('disabled');
                    $('.cart-item').removeClass('error-count');
                    $('.cart-item').find('.choices').removeClass('error-count');
                }

                recalculatePriceBlock();
            });

            //индекс - макс 6 цифр
            $('#user_index').on('input', function () {
                if (this.value.length > 6) {
                    this.value = this.value.slice(0, 6);
                }

                validateField($(this));
            });

            //уход с инпута индекса - запрос за стоимостью и временем доставки
            $('#user_index').on('blur', function () {
                if (this.value.length === 6) {
                    getDeliveryValues();
                }
            });

            //все остальные поля - макс 40 символов
            $('#user_name, #user_lastName, #user_oblast, #user_city, #user_address, #user_email').on('input', function () {
                if (this.value.length > 40) {
                    this.value = this.value.slice(0, 40);
                }

                validateField($(this));
            });

            $userPhoneInput.on('input', function () {
                validateField($(this));
            });

            //свитчер по бонусам
            if ($bonusesSwitcher.length) {
                $bonusesSwitcher.on('click', function (e) {
                    e.preventDefault();
                    $(this).find('.switcher-gray').toggleClass('active');

                    if(PROMOCODE.isPromocodeAccepted){
                        const promocodeVal = $('#promocode_input').val().trim('');

                        validatePromocode(promocodeVal, false);
                        showCartPreloader();
                        getPoints();

                    }else{
                        showCartPreloader();
                        getPoints();

                        recalculatePriceBlock();
                    }
                });
            }

            //закрытие модалки статуса заказа
            $closeCartStatusModal.on('click', () => {
                hideModal($closeCartStatusModal);
            });
            //отправка пароля на подтверждение почты
            $('[data-send-code]').on('click', function () {
                checkPassword();
            });

            //повторная отправка кода
            $('body').on('click','.check-password-timer.finished', function () {
                $('.check-password-timer').removeClass('finished');
                sendPassword();
            });

            //валидация поля отправки пароля
            $('#email_code').on('blur', e => {
                validateCheckPasswordInput();
            });

            $('#email_code').on('input', () => {
                $('#email_code').val($('#email_code').val().replace(/[^0-9.]/g, ''));
            });

            //при переключении магазинов для самовывоза - активируем кнопку (если есть переключение - они доступны)
            $('input[name="address"]').on('change', e => {
                $('[data-submit-order]').removeClass('disabled')
            });

            //кнопка промокода
            $('input[name="promocode-input"]').on('input', function (){
               const inputVal = $(this).val();
               $(this).val(`${inputVal.replace(/[А-Яа-яЁё]/g,'')}`);

               if(inputVal){
                   $('.promocode-btn').removeClass('hide');
               }else{
                   $('.promocode-btn').addClass('hide');
               }
            });

            //валидация промокода
            $('.promocode-btn').on('click', function (){
                const promocodeVal = $(this).siblings('label').find('input').val().trim('');

                validatePromocode(promocodeVal, true);
            });

            //удаление промокода из заказа
            $('.promocodes-block').on('click', 'svg', function (){
                PROMOCODE.isPromocodesAvailable = false;
                PROMOCODE.isPromocodeAccepted = false;
                PROMOCODE.code = null;
                handlePromocode();
            });

            // перезагрузка корзины
            $('[data-refresh-card-page]').on('click', function (){
                window.location.reload();
            });
        }

        //запрос за валидацией промокода
        function validatePromocode(promocodeVal, checkBonusesAvailable = false){
            showFullScreenPreloader();

            const data = {
                ajaxAction: "validatePromoCode",
                promoCode: promocodeVal,
                bonus: $('.switcher-gray').hasClass('active') ? bonusesWriteOff : 0
            }

            $.ajax({
                url: `/ajax/cart/`,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (data && data?.promocode && data?.promocode?.discount_value && data?.promocode?.discount_type) {
                        promocodeValidationSuccess(data.promocode);

                    } else {
                        promocodeValidationError(data);
                    }
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.validatePromocode.success.payload;
                        if (data && data?.promocode && data?.promocode?.discount_value && data?.promocode?.discount_type) {
                            promocodeValidationSuccess(data.promocode);

                        } else {
                            promocodeValidationError(data);
                        }
                    } else {
                        promocodeValidationError(data);
                    }
                },
                timeout: 30000
            });

            function promocodeValidationSuccess(promocodeData){
                PROMOCODE.discount_type = promocodeData.discount_type;
                PROMOCODE.discount_value = promocodeData.discount_value;
                PROMOCODE.min_value = promocodeData.min_value;
                PROMOCODE.code = promocodeVal;
                PROMOCODE.isPromocodesAvailable = true;
                PROMOCODE.isPromocodeAccepted = true;

                $('.promocode-error').text('');
                $('.promocode-error').addClass('hide');

                $('.promocode-success').removeClass('hide');

                handlePromocode();

                if(checkBonusesAvailable){
                    getPoints(true);
                }

                hideFullScreenPreloader();
            }

            function promocodeValidationError(data){
                $('#promocode_input').siblings('.error-message').text(data.errorText);
                $('#promocode_input').parent().addClass('error');
                $('.promocode-error').text(data.errorText);
                $('.promocode-error').removeClass('hide');
                $('.promocode-success').addClass('hide');
                PROMOCODE.isPromocodeAccepted = false;

                hideFullScreenPreloader();
            }
        }

        function removeCartItem(cartItemInfo) {
            showCartPreloader();
            const ajaxData = {
                ajaxAction: "remove",
                itemCartId: cartItemInfo.itemCartId
            }

            $.ajax({
                url: '/ajax/cart/',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(ajaxData),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    successFn(data, cartItemInfo);
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.removeCartItem;
                        if (data) {
                            successFn(data.payload, cartItemInfo);

                        } else {
                            errorFn();
                        }

                    } else {
                        errorFn();
                    }
                },
                timeout: 30000
            });

            function successFn(payload, cartItemInfo) {
                if (payload?.cartItems.length === 0) {
                    showNoCartItemsMessage();
                    $pagePreloader.hide();

                }else{
                    const result = renderCartItems(payload);
                    $cartWrapper.html(result);
                    initSelects();
                    initRerenderedButtons();
                    let currentItemsCount = 0;

                    $cartWrapper.find('.cart-item').each((_, cartItem) => {
                        if ($(cartItem).data('cart-item-info').itemCartId === cartItemInfo.itemCartId) {
                            $(cartItem).remove();

                            if (!$cartWrapper.find('.cart-item').length) {
                                showNoCartItemsMessage();
                                return;
                            }
                        }
                    });

                    $('.select.choices__input').each((_, select) => {
                        const selectVal = +$(select).val();
                        currentItemsCount += selectVal;
                    });

                    $cartItemsCount.text(`${currentItemsCount} ${getRightTerm(currentItemsCount, 'товар', 'товара', 'товаров')}`);
                    $headerCartCount.text(currentItemsCount);
                    $mobCartCount.text(currentItemsCount);

                    //сбрасываем промо при любом удалении товара (хендл промо вызовет за собой запрос getBonusData)
                    PROMOCODE.isPromocodesAvailable = false;
                    PROMOCODE.isPromocodeAccepted = false;
                    PROMOCODE.code = null;
                    handlePromocode();

                    /*if(!payload.canUsePromoCode){
                        PROMOCODE.isPromocodesAvailable = false;
                        handlePromocode();
                    }*/
                    recalculatePriceBlock();
                }
                hideCartPreloader();
            }

            function errorFn() {
                hideCartPreloader();
            }
        }

        function editCartItem(ajaxData, cartItemInfo) {
            showCartPreloader();

            $.ajax({
                url: '/ajax/cart/',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(ajaxData),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (data) {
                        successFn(data, cartItemInfo);

                    } else {
                        errorFn();
                    }
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.editCartItem;
                        if (data) {
                            successFn(data.payload, cartItemInfo);

                        } else {
                            errorFn();
                        }

                    } else {
                        errorFn();
                    }
                },
                timeout: 30000
            });

            function successFn(payload, cartItemInfo) {
                const result = renderCartItems(payload);
                $cartWrapper.html(result);
                initSelects();
                initRerenderedButtons();

                let currentItemsCount = 0;

                $('.select.choices__input').each((_, select) => {
                    const selectVal = +$(select).val();
                    currentItemsCount += selectVal;
                });

                $cartItemsCount.text(`${currentItemsCount} ${getRightTerm(currentItemsCount, 'товар', 'товара', 'товаров')}`);
                $headerCartCount.text(currentItemsCount);
                $mobCartCount.text(currentItemsCount);

                $cartWrapper.find('.cart-item').each((_, cartItem) => {
                    if ($(cartItem).data('cart-item-info').itemCartId === cartItemInfo.itemCartId) {
                        const cartItemCount = +$(cartItem).data('cart-item-info').count;
                        const cartItemPrice = +$(cartItem).data('cart-item-info').price;

                        const cartItemFullPrice = cartItemCount * cartItemPrice;
                        $(cartItem).find('[data-cart-item-price]').data('cart-item-price', cartItemFullPrice);
                        $(cartItem).find('[data-cart-item-price]').text(`${numberFormat(cartItemFullPrice, '', '', ' ')} ₽`);

                        if ($(cartItem).data('cart-item-info').isDiscount) {
                            const oldPrice = +$(cartItem).data('cart-item-info').price * cartItemCount;
                            const newPrice = +$(cartItem).data('cart-item-info').discountPrice * cartItemCount;

                            $(cartItem).find('[data-cart-item-sale-price]').data('cart-item-sale-price', oldPrice);
                            $(cartItem).find('[data-cart-item-sale-price]').text(`${numberFormat(oldPrice, '', '', ' ')} ₽`);

                            $(cartItem).find('[data-cart-item-price]').data('cart-item-price', newPrice);
                            $(cartItem).find('[data-cart-item-price]').text(`${numberFormat(newPrice, '', '', ' ')} ₽`);
                        }

                    }
                });

                if(!payload.canUsePromoCode){
                    PROMOCODE.isPromocodesAvailable = false;
                    handlePromocode();
                }

                getPoints();
                recalculatePriceBlock();
                hideCartPreloader();
            }

            function errorFn() {
                hideCartPreloader()
            }
        }

        function sendOrder() {
            let data = {};
            const currentDeliveryType = $('input[name="delivery"]:checked').val();

            const mobilePhoneValue = $userPhoneInput.val();
            let mobilePhoneValueWithCodes = `+7 (${mobilePhoneValue[0]}${mobilePhoneValue[1]}${mobilePhoneValue[2]}) ${mobilePhoneValue[3]}${mobilePhoneValue[4]}${mobilePhoneValue[5]}-${mobilePhoneValue[6]}${mobilePhoneValue[7]}-${mobilePhoneValue[8]}${mobilePhoneValue[9]}`

            if (!mobilePhoneValue) {
                mobilePhoneValueWithCodes = '';
            }

            const promocode = {
                code: null
            }

            if(PROMOCODE.isPromocodesAvailable){
                promocode.code = PROMOCODE.code;
            }

            if (currentDeliveryType === '1') {
                data = {
                    ajaxAction: "add",
                    itemCartIds: [],
                    deliveryType: 1,
                    shopId: +$('input[name="address"]:checked').val(),
                    firstName: $userNameInput.val(),
                    email: $userEmailInput.val(),
                    lastname: $('#user_lastName').val(),
                    phone: mobilePhoneValueWithCodes,
                    promocode: promocode,
                    bonus: $('.switcher-gray').hasClass('active') ? bonusesWriteOff : 0
                }

            } else if (currentDeliveryType === '2') {
                data = {
                    ajaxAction: "add",
                    itemCartIds: [],
                    deliveryType: 2,
                    firstName: $userNameInput.val(),
                    email: $userEmailInput.val(),
                    phone: mobilePhoneValueWithCodes,
                    index: $('#user_index').val(),
                    lastname: $('#user_lastName').val(),
                    country: $('#user_country').val(),
                    city: $('#user_city').val(),
                    oblast: $('#user_oblast').val(),
                    address: $('#user_address').val(),
                    deliveryPrice,
                    promocode: promocode,
                    bonus: $('.switcher-gray').hasClass('active') ? bonusesWriteOff : 0
                }
            }

            $cartWrapper.find('.cart-item').each((_, cartItem) => {
                data.itemCartIds.push(+$(cartItem).data('cart-item-info').itemCartId);
            });

            $.ajax({
                url: `/ajax/order/`,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (data) {
                        successFn(data);

                    } else {
                        errorFn(data);
                    }
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.sendOrder;
                        if (data) {
                            successFn(data);

                        } else {
                            errorFn(data);
                        }

                    } else {
                        errorFn(data);
                    }
                },
                timeout: 30000
            });

            function successFn(data) {
                if (data && data?.link) {
                    window.location.href = data?.link;

                } else {
                    errorFn(data);
                }
            }

            function errorFn(data) {
                if(data?.statusText && data.statusText === 'Ошибка при использовании промокода'){
                    showDynamicErrorModal(data);

                }else{
                    $cartStatusModal.find('.error').css('display', 'flex');
                    showModal($cartStatusModal);
                }
            }
        }

        function validateInputs(deliveryType) {
            if (deliveryType === '1') {
                if (validateForm($('[data-user-fields]'))) {
                    return true;
                }

            } else if (deliveryType === '2') {
                if (validateForm($('[data-user-fields]')) && validateForm($postDeliveryBlock)) {
                    return true;
                }
            }

            return false
        }

        function showNoCartItemsMessage() {
            $('[data-main-cart-container]').html('');
            $('.mobile-cart-info').hide();
            $('h2.controls-name').hide();

            const noCartItemsHTML = `
                <h2 class="h2">В корзине пока ничего нет</h2>
                <p class="body-16 m-w-396 mob-w-100">Но вы можете это исправить. Перейдите в каталог и найдите то, что вам нравится</p>
                <a href="/" class="button theme-yandex m-w-342 mob-w-100 border-radius-35">Перейти в каталог</a>
            `;

            $('[data-main-cart-container]').append(noCartItemsHTML);
            $('[data-cart-count-desk]').add('[data-cart-count-mob]').hide();
        }

        function recalculatePriceBlock() {
            const $oldOrderPrice = $('[data-old-order-price]');
            let newOrderPrice = 0;
            let newSalePrice = 0;
            let newOrderPriceWithoutSale = 0;
            let deliveryHTML = '0 ₽';
            let deliveryChangedPrice = 0;
            let bonuses = 0;
            let priceWithPromocode = 0;

            $cartWrapper.find('.cart-item').each((_, cartItem) => {
                const cartItemFullPrice = +$(cartItem).find('[data-cart-item-price]').data('cart-item-price');
                const cartItemSalePrice = +$(cartItem).find('[data-cart-item-sale-price]').data('cart-item-sale-price');

                newOrderPrice += cartItemFullPrice;
                if ($(cartItem).data('cart-item-info').isDiscount) {
                    newSalePrice += cartItemSalePrice - cartItemFullPrice;
                    newOrderPriceWithoutSale += +$(cartItem).data('cart-item-info').price * +$(cartItem).data('cart-item-info').count;

                } else {
                    newOrderPriceWithoutSale += +$(cartItem).data('cart-item-info').price * +$(cartItem).data('cart-item-info').count;
                }
            });

            const deliveryVariant = $('input[name="delivery"]:checked').val();

            if (deliveryVariant === '2') {
                if(deliveryPrice !== 0){
                    deliveryChangedPrice = deliveryPrice;
                    deliveryHTML = `${getRightPrice(deliveryChangedPrice)} ₽`;
                    $('[data-delivery-time]').find('span.h5-bold').text(`${deliveryTime} ${getRightTerm(deliveryTime, 'день', 'дня', 'дней')}`);
                    $('[data-delivery-time]').show();
                }

            }else{
                deliveryChangedPrice = 0;
                $('[data-delivery-time]').hide();
            }

            if ($('.switcher-gray').hasClass('active')) {
                bonuses = bonusesWriteOff;
                $('.green-points').hide();

            } else {
                $('.green-points').show();
            }

            $orderPrice.text(`${numberFormat(newOrderPriceWithoutSale, '', '', ' ')} ₽`);

            if(+newSalePrice === 0){
                $salePrice.text(`${numberFormat(newSalePrice, '', '', ' ')} ₽`);

            }else{
                $salePrice.text(`- ${numberFormat(newSalePrice, '', '', ' ')} ₽`);
            }

            $deliveryPrice.text(deliveryHTML);

            //бонусы не списаны, промо не применён
            if (!$('.switcher-gray').hasClass('active') && !PROMOCODE.isPromocodeAccepted) {
                $oldOrderPrice.text('');
                $fullOrderPrice.text(`${getRightPrice(ORDER_PRICE_FROM_BACK.fullPrice + deliveryChangedPrice)} ₽`);
            }

            // бонусы списаны, промо нет
            if ($('.switcher-gray').hasClass('active') && !PROMOCODE.isPromocodeAccepted){
                $oldOrderPrice.text(`${getRightPrice(ORDER_PRICE_FROM_BACK.fullPrice + deliveryChangedPrice)}`);
                $fullOrderPrice.text(`${getRightPrice(ORDER_PRICE_FROM_BACK.writeOff + deliveryChangedPrice )} ₽`);
            }

            // промо применён, бонусы не списаны
            if (!$('.switcher-gray').hasClass('active') && PROMOCODE.isPromocodeAccepted){
                $oldOrderPrice.text(`${getRightPrice(ORDER_PRICE_FROM_BACK.fullPrice + deliveryChangedPrice)}`);
                $fullOrderPrice.text(`${getRightPrice(ORDER_PRICE_FROM_BACK.accrue + deliveryChangedPrice)} ₽`);
            }

            // промо применён, бонусы списаны
            if ($('.switcher-gray').hasClass('active') && PROMOCODE.isPromocodeAccepted){
                $oldOrderPrice.text(`${getRightPrice(ORDER_PRICE_FROM_BACK.fullPrice + deliveryChangedPrice)}`);
                $fullOrderPrice.text(`${getRightPrice(ORDER_PRICE_FROM_BACK.writeOff + deliveryChangedPrice)} ₽`);
            }
        }

        function handlePromocode(){
            if(PROMOCODE.isPromocodesAvailable){
                $('[data-promocode-in-price-block-value]').text(`- ${PROMOCODE.discount_value} ${PROMOCODE.discount_type}`);
                $('[data-promocode-in-price-block]').removeClass('hide');
                $('input[name="promocode-input"]').parent().addClass('disabled');

                $('input[name="promocode-input"]').attr('disabled', true);

                $('.promocode-btn').addClass('hide');
                $('.promocodes-block').find('svg').removeClass('hide');

            }else{
                PROMOCODE.isPromocodesAvailable = false;
                PROMOCODE.discount_value = 0;
                PROMOCODE.discount_type = '';
                PROMOCODE.min_value = 0;
                $('[data-promocode-in-price-block-value]').text(``);
                $('[data-promocode-in-price-block]').addClass('hide');
                $('input[name="promocode-input"]').parent().removeClass('disabled');

                $('input[name="promocode-input"]').attr('disabled', false);
                $('.promocode-success').addClass('hide');

                $('input[name="promocode-input"]').val('');
                $('.promocodes-block').find('svg').addClass('hide');

                showFullScreenPreloader();
                getPoints();
                hideFullScreenPreloader();
            }

            recalculatePriceBlock();
        }

        //отправление кода подтверждения на почту
        function sendPassword() {
            showFullScreenPreloader();

            const emailValue = $userEmailInput.val();

            $('#email_code').attr('maxLength', 6);

            const data = {
                "login": emailValue
            }

            $.ajax({
                url: `${AJAX_AUTH_URL}/sendPassword`,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    success(data);
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.sendPassword;
                        success(data);
                    } else {
                        error(data);
                    }
                },
                timeout: 30000
            });

            function success() {
                hideFullScreenPreloader();

                let timer = 60;

                $('[data-send-password-timer]').text(`Отправить повторно через ${timer} сек.`);
                //включаем счетчик
                sendPasswordTimeInterval = setInterval(() => {
                        timer--;

                        if (timer === 0) {
                            clearInterval(sendPasswordTimeInterval);
                            $('[data-send-password-timer]').addClass('finished');
                            $('[data-send-password-timer]').text(`Отправить повторно`);

                        } else {
                            $('[data-send-password-timer]').text(`Отправить повторно через ${timer} сек.`);
                        }

                    }, 1000
                );
            }

            function error(data) {
            }
        }

        //отправка полученного кода для подтверждения телефона/почты
        function checkPassword() {
            if (!validateCheckPasswordInput()) {
                return;
            }

            showFullScreenPreloader();

            const data = {
                code: $('#email_code').val(),
                login: $userEmailInput.val()
            }

            $.ajax({
                url: `${AJAX_AUTH_URL}/checkPassword`,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    success(data);
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.checkPassword;
                        success(data);
                    } else {
                        error(data);
                    }
                },
                timeout: 30000
            });

            function success(data) {
                if (data?.status === 'success') {
                    getUserProfile();

                    //время жизни кода истекло или некорректный код
                } else if (data?.status === 'expired' || data?.status === 'incorrect') {
                    $('[data-send-password-status]').text('Введен неверный код');
                    $('[data-send-password-status]').show();
                    hideFullScreenPreloader();
                }
            }

            function error() {

            }
        }

        //получение стоимости и сроков доставки
        function getDeliveryValues(){
            /*showFullScreenPreloader();*/
            $('#user_index').parent().addClass('disabled');
            $('[data-submit-order]').addClass('disabled');

            const data = new FormData();

            data.append('type', 'tariff');
            data.append('entity', 'ems');
            data.append('postcode', +$('#user_index').val());

            $.ajax({
                url: `/ajax/russian-post/`,
                type: 'POST',
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                dataType: 'json',
                data: data,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    success(data);
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.getDeliveryValues;
                        success(data);
                    } else {
                        error(data);
                    }
                },
                timeout: 30000
            });

            function success(data) {
                if (data?.status === 'success' && data?.paynds && data?.days) {
                    deliveryPrice = +data.paynds;
                    deliveryTime = data.days;
                    $('#user_index').parents('.field').addClass('success').removeClass('error').removeClass('disabled');
                    $('[data-submit-order]').removeClass('disabled');
                    recalculatePriceBlock();

                }else{
                    deliveryPrice = 0;
                    deliveryTime = 0;
                    error();
                }
            }

            function error() {
                $('#user_index').parents('.field').removeClass('success').removeClass('disabled').addClass('error');
                $('[data-submit-order]').addClass('disabled');
                recalculatePriceBlock();
            }
        }

        //получение баллов
        function getPoints(){
            const data = {
                orderPrice: fullOrderPrice,
                application: "store",
                products: [],
                promocode: PROMOCODE.code || null
            }

            $cartWrapper.find('.cart-item').each((_, cartItem) => {
                const productData = {}

                productData.id = +$(cartItem).data('cart-item-info').productId;
                productData.isDiscount = false;

                if(+$(cartItem).data('cart-item-info')?.discountPrice){
                    productData.price = +$(cartItem).data('cart-item-info').discountPrice;
                    productData.isDiscount = true;

                }else{
                    productData.price = +$(cartItem).data('cart-item-info').price;
                }

                productData.count = +$(cartItem).data('cart-item-info').count;

                data.products.push(productData);
            });

            $.ajax({
                url: `${AJAX_AUTH_URL}/api/bonus/getBonusData`,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    success(data);
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.getBonuses;
                        success(data);
                    } else {
                        error(data);
                    }
                },
                timeout: 30000
            });

            function success(data){
                if(data && data.status === 'OK'){

                    //основные знач бонусов
                    if (data.payload.count && data.payload.count !== '0' && data.payload.count !== 0
                        && data.payload.maxWriteOff && data.payload.maxWriteOff !== '0' && data.payload.maxWriteOff !== 0) {

                        if($('[data-use-user-points-block]').is(':hidden')){
                            $('[data-use-user-points-block]').show();
                        }

                        $bonusesWriteOff.text(data.payload.maxWriteOff);
                        $bonusesAll.text(data.payload.count);
                        userPoints = +data.payload.count;
                        bonusesWriteOff = +data.payload.maxWriteOff;
                    } else {
                        $('[data-use-user-points-block]').hide();

                        if($('[data-use-user-points-block] .switcher-gray').hasClass('active')){
                            $('[data-use-user-points-block] .switcher-gray').removeClass('active')
                        }
                    }

                    //зеленая плашка
                    if(data.payload.maxAccrue && data.payload.maxAccrue !== '0' && data.payload.maxAccrue !== 0 && isUserAuthorized){
                        $('[data-plus-points]').text(`+ ${data.payload.maxAccrue} ${getRightTerm(data.payload.maxAccrue, 'бонус', 'бонуса', 'бонусов')}`);
                        $('[data-plus-points]').removeClass('hide');

                    }else{
                        $('[data-plus-points]').addClass('hide');
                    }

                    //сообщение (warning) в промо
                    if(data.payload?.promoCode?.message && PROMOCODE.code){
                        $('[data-promocode-message]').text(data.payload.promoCode.message);
                        $('[data-promocode-message]').removeClass('hide');
                    }else{
                        $('[data-promocode-message]').addClass('hide');
                    }

                    //сумма заказа с бека
                    ORDER_PRICE_FROM_BACK.writeOff = data.payload.amountPay.writeOff;
                    ORDER_PRICE_FROM_BACK.accrue = data.payload.amountPay.accrue;
                    ORDER_PRICE_FROM_BACK.fullPrice = data.payload.amountPay.fullPrice;

                    recalculatePriceBlock();

                }else{
                    showDynamicErrorModal(data);
                }

                $pagePreloader.hide();
            }

            function error(data){
                showDynamicErrorModal(data);
            }
        }

        function showDynamicErrorModal(data){
            $dynamicCartErrorModal.find('[data-dynamic-error-modal-text]').text(data?.statusText || 'Произошла непредвиденная ошибка');
            $dynamicCartErrorModal.find('.error').css('display', 'flex');
            showModal($dynamicCartErrorModal);
        }

        function getUserProfile() {
            $.ajax({
                url: `${AJAX_USER_PROFILE_URL}/getUserProfile`,
                type: 'GET',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    success(data);
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.getUserProfile;
                        success(data);
                    } else {
                        error(data);
                    }
                },
                timeout: 30000
            });

            function success(data) {
                if (data) {
                    setUserFields(data);

                } else {
                    error();
                }
            }

            function error() {
                sendOrder();
            }

            function setUserFields(data) {
                //создаём объект, где будем менять данные и переносим туда поля с данных о пользователе с сервера
                let newUserData = {};
                Object.assign(newUserData, data);

                //если какое-то из полей пустое - вводим заполненные пользователем данные
                if (newUserData.name === null || newUserData.name === '') {
                    newUserData.name = USER.name;
                }

                if (newUserData.lastname === null || newUserData.lastname === '') {
                    newUserData.lastname = USER.lastname;
                }

                if (newUserData.address === null || newUserData.address === '') {
                    newUserData.address = USER.address;
                }

                if (newUserData.city === null || newUserData.city === '') {
                    newUserData.city = USER.city;
                }

                $.ajax({
                    url: `${AJAX_USER_PROFILE_URL}/saveUserProfile`,
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(newUserData),
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        success(data);
                    },
                    error: function () {
                        if (AJAX_MODE === 'dev') {
                            success();
                        }
                    },
                    timeout: 30000
                });

                function success() {
                    sendOrder();
                }
            }
        }

        function showFullScreenPreloader() {
            $fullScreenPreloader.css('display', 'flex');
        }

        function hideFullScreenPreloader() {
            $fullScreenPreloader.hide();
        }

        function showCartPreloader(){
            $pagePreloader.css('display', 'flex');
        }

        function hideCartPreloader(){
            $pagePreloader.css('display', 'none');
        }

        function initRerenderedButtons(){
            //удаление товара
            $('.cart-item-delete').off();
            $('.cart-item-delete').on('click', e => {
                const $clickedDelete = $(e.currentTarget);
                const cartItemInfo = $clickedDelete.parents('.cart-item').data('cart-item-info');

                removeCartItem(cartItemInfo);
            });

            //при переключении адреса самовывоза - активируем кнопку на оплату заказа (если доступно переключение - доступен и самовывоз)
            $('input[name="address"]').off();
            $('input[name="address"]').on('change', e => {
                $('[data-submit-order]').removeClass('disabled');
            });
        }
    }
}